import { Box, BoxProps } from '@chakra-ui/react'

function CircularKoraenIcon({ ...props }: BoxProps) {
    return (
        <Box
            cursor={'pointer'}
            {...props}
        >
            <svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="9.99996" cy="10.5003" r="8.33333" stroke="currentColor" stroke-width="1.5" />
                <path d="M5.83325 7.48341H9.58325M14.1666 7.48341H12.0833M9.58325 7.48341H12.0833M9.58325 7.48341V6.33398M12.0833 7.48341C11.6437 9.05533 10.7232 10.5413 9.67254 11.8471M6.99397 14.6673C7.84329 13.8863 8.80254 12.9285 9.67254 11.8471M9.67254 11.8471C9.13682 11.219 8.38682 10.2028 8.17254 9.74308M9.67254 11.8471L11.2797 13.5179" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
            </svg>
        </Box>
    )
}

export { CircularKoraenIcon }
